import React from 'react';
import api from '../api';
import { createMuiTheme, makeStyles, MuiThemeProvider, InputAdornment, Paper, Switch, TableCell, Tabs, Tab, Typography, withStyles, Snackbar, Tooltip } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import EditJadwalDokter from './editJadwalDokter';
import Loader from 'react-loader-spinner'
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import back from '../../assets/ic_back.png';
import MuiAlert from '@material-ui/lab/Alert';
import next from '../../assets/ic_next.png';
import editIcon from '../../assets/1@3x.png';
import EditJadwalPoli from './editJadwalPoli';
import ic_search from '../../assets/ic_search.png';
import { format } from 'date-fns';
import CloseIcon from '@material-ui/icons/Close';
import SearchComponent from '../components/search/SearchComponent'

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable3());
const options = ct.customOptions()

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

export default function JadwalTransaksiPoli(props) {
    const history = useHistory();
    const classes = useStyles()
    const [jadwal, setJadwal] = React.useState([]);
    const [visibleDetail, setVisibleDetail] = React.useState(false)
    const [value, setValue] = React.useState(0);
    const [valueID, setValueID] = React.useState(0);
    const [list, setList] = React.useState([]);
    const [limitDate, setLimitDate] = React.useState([])
    const [selectedSchedule, setSelectedSchedule] = React.useState([])
    const [loading, setLoading] = React.useState(false);
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const date = new Date()
    const [displayStartDate, setDisplayStartDate] = React.useState("");
    const [displayEndDate, setDisplayEndDate] = React.useState("")
    const [startDate, setStartDate] = React.useState("")
    const [endDate, setEndDate] = React.useState("")
    const [dayBeforeWeek, setDayBeforeWeek] = React.useState("")
    const [visibleEdit, setVisibleEdit] = React.useState(false)
    const [visibleSearch, setVisibleSearch] = React.useState(false)
    const [searchName, setSearchName] = React.useState(null)
    const [create, setCreate] = React.useState(false);
    const [read, setRead] = React.useState(false);
    const [update, setUpdate] = React.useState(false);
    const [deleted, setDeleted] = React.useState(false);
    const [range, setRange] = React.useState(0)
    const [updateRange, setUpdateRange] = React.useState(0)
    const [disableNext, setDisableNext] = React.useState(false)
    function changeDate(startDate, endDate) {

    }

    const handleChange = (event) => {
        console.log(event);
        let temp = []
        event.schedule.map((el, idx) => {
            el["no"] = idx + 1
            // console.log(el);
            temp.push(el.date)
        })
        setLimitDate(temp)
        setValue(event)
        setValueID(event.polyclinic_id)
    };

    const handleSeeDetail = (data) => {
        // setVisibleDetail(true)
        setVisibleEdit(true)
        console.log(data.rowData);
        let tanggal = data.rowData[1]
        console.log(tanggal);
        let schedules = value.schedule
        let tempData;
        console.log(value);
        schedules.map(el => {
            console.log(el);
            if (tanggal === el.schedule_date) {
                tempData = el
                setSelectedSchedule(data.rowData)
            }
        })
        console.log(tempData);
    }

    const columns = [
        {
            name: "no",
            label: "No"
        },
        {
            name: "schedule_date",
            label: "Tanggal Jadwal"
        },
        {
            name: "time_start",
            label: "Jam Mulai"
        },
        {
            name: "time_end",
            label: "Jam Selesai"
        },
        update ? {
            name: "Aksi",
            options: {
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex' }}>
                            {update && (
                                <LightTooltip title={"Edit"} arrow>
                                    <button
                                        onClick={() => handleSeeDetail(tableMeta)}
                                        style={{
                                            backgroundColor: "transparent",
                                            fontSize: 20,
                                            outline: 'none',
                                            borderColor: 'transparent'
                                        }}>
                                        <img src={editIcon} style={{ width: 30, height: 30 }} />
                                    </button>
                                </LightTooltip>
                            )}
                        </div>
                    )
                }
            }
        } : {
            name: 'id',
            options: {
                display: 'none'
            }
        },
        {
            name: 'id',
            options: {
                display: 'none'
            }
        }
    ];

    const getDateNow = (s, e) => {
        let tanggal = format(s, 'dd')
        let month = format(s, 'MM')
        let year = format(s, 'yyyy')
        switch (month) {
            case '01':
                month = "Januari"
                break;
            case '02':
                month = "Februari"
                break;
            case '03':
                month = "Maret"
                break;
            case '04':
                month = "April"
                break;
            case '05':
                month = "Mei"
                break;
            case '06':
                month = "Juni"
                break;
            case '07':
                month = "Juli"
                break;
            case '08':
                month = "Agustus"
                break;
            case '09':
                month = "September"
                break;
            case '10':
                month = "October"
                break;
            case '11':
                month = "November"
                break;
            default:
                month = "Desember"
                break;
        }

        let formatPlusWeek = new Date(s).setDate(new Date(s).getDate() + 7);
        // console.log(format(formatPlusWeek, 'dd MMM yyyy'));
        let tanggalAfterWeek = format(formatPlusWeek, 'dd')
        let monthAfterWeek = format(formatPlusWeek, 'MM')
        let yearAfterWeek = format(formatPlusWeek, 'yyyy')
        switch (monthAfterWeek) {
            case '01':
                monthAfterWeek = "Januari"
                break;
            case '02':
                monthAfterWeek = "Februari"
                break;
            case '03':
                monthAfterWeek = "Maret"
                break;
            case '04':
                monthAfterWeek = "April"
                break;
            case '05':
                monthAfterWeek = "Mei"
                break;
            case '06':
                monthAfterWeek = "Juni"
                break;
            case '07':
                monthAfterWeek = "Juli"
                break;
            case '08':
                monthAfterWeek = "Agustus"
                break;
            case '09':
                monthAfterWeek = "September"
                break;
            case '10':
                monthAfterWeek = "October"
                break;
            case '11':
                monthAfterWeek = "November"
                break;
            default:
                monthAfterWeek = "Desember"
                break;
        }

        let startDate = `${tanggal} ${month} ${year}`
        let endDate = `${tanggalAfterWeek} ${monthAfterWeek} ${yearAfterWeek}`
        let realStart = `${year}-${new Date(s).getMonth() + 1}-${tanggal}`
        let realEnd = `${yearAfterWeek}-${new Date(formatPlusWeek).getMonth() + 1}-${tanggalAfterWeek}`
        setStartDate(String(realStart))
        setEndDate(String(realEnd))
        setDisplayStartDate(String(startDate))
        setDisplayEndDate(String(endDate))
        getJadwalFilter(String(realStart), String(realEnd))
        forceUpdate()
    }

    React.useEffect(() => {
        props.setShowNotif(true)
        // getJadwal()
        getDateNow(new Date())
        getJadwalFilter()
        setLoading(true)
        getPermission(props)
        getParameter()
    }, [])

    const getParameter = () => {
        api.create().getParameter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    response.data.data.map((item) => {
                        if (item.param_code === "MAX_DATE_RANGE") {
                            setRange(Number(item.param_value))
                            setUpdateRange(Number(item.param_value))
                        }
                    })
                }
            }
        })
    }

    const getPermission = (e) => {
        api.create().getPermission(e.menuid).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setCreate(data.create)
                    setUpdate(data.update)
                    setRead(data.read)
                    setDeleted(data.delete)
                }
            }
        })
    }

    // const getJadwal = () => {
    //     api.create().getScheduleTransaction().then(response => {
    //         console.log(response)
    //         setList(response.data.data)
    //         setLoading(false)
    //     })
    // }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const getJadwalFilter = (start, end) => {
        setLoading(true)
        let param = `"start:${start}`
        if (end) {
            param = `"start":"${start}","end":"${end}"`
        }
        api.create().getSchedulePoliTransactionFilter(param).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        let data = []
                        response.data.data.map((el) => {
                            if (el.deleted_at === null) {
                                data.push(el)
                                if (el.name === jadwal.name) {
                                    el.schedule.map((item, idx) => {
                                        item["no"] = idx + 1
                                        // console.log(item);
                                    })
                                    setValue(el)
                                    setJadwal(el)
                                }
                            }
                        })
                        setList(data)
                    } else {
                        setValue(0)
                    }
                    setLoading(false)
                }
            }
            console.log(jadwal);
        })
    }

    const doFilter = (key) => {
        setLoading(true)
        if (key === null) {
            api.create().getJadwalTransaksiFilter().then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        if (list.length >= 1) {
                            let data = []
                            response.data.data.map((el) => {
                                if (el.deleted_at === null) {
                                    data.push(el)
                                    console.log(el);
                                    if (el.name === jadwal.name) {
                                        el.schedule.map((item, idx) => {
                                            item["no"] = idx + 1
                                            // console.log(item);
                                        })
                                        setValue(el)
                                        setJadwal(el)
                                    }
                                }
                            })
                            setList(data)
                        } else {
                            setValue(0)
                        }
                        setLoading(false)
                    }
                }
            })
        } else {
            let param = `keyword=${key}`
            api.create().getJadwalTransaksiFilter(param).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        if (response.data.data.length > 0) {
                            let data = []
                            response.data.data.map((el) => {
                                if (el.deleted_at === null) {
                                    data.push(el)
                                    if (el.name === jadwal.name) {
                                        el.schedule.map((item, idx) => {
                                            item["no"] = idx + 1
                                            // console.log(item);
                                        })
                                        setValue(el)
                                        setJadwal(el)
                                    }
                                }
                            })
                            setList(data)
                        } else {
                            setValue(0)
                        }
                        setLoading(false)
                    }
                }
            })
        }
    }

    const handleClick = (e) => {
        console.log(e);
        setJadwal(e)
        let temp = []
        e.schedule.map((el, idx) => {
            el["no"] = idx + 1
        })
        // e.polyclinic[0].schedule.map((el, idx) => {
        //     el["no"] = idx + 1
        //     temp.push(el.date)
        // })
        setValue(e)
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleBack = (val) => {
        let fixRange = updateRange + val
        setUpdateRange(fixRange)
        console.log(val);
        let a = new Date(startDate).setDate(new Date(startDate).getDate() - val);
        console.log(a);
        let b = new Date(a).getDate()
        let c = new Date(a).getMonth()
        let d = new Date(a).getFullYear()
        let date = `${d}-${c + 1}-${b}`
        console.log(date);
        getDateNow(new Date(date))
        setDisableNext(false)
    }
    let checkDate = `${displayStartDate[0]}${displayStartDate[1]}`
    // console.log(displayStartDate);
    const handleNext = (val) => {
        let fixRange = updateRange - val
        console.log(val);
        if (fixRange <= 7) {
            let a = new Date(startDate).setDate(new Date(startDate).getDate() + val);
            let b = new Date(a).getDate()
            let c = new Date(a).getMonth()
            let d = new Date(a).getFullYear()
            let date = `${d}-${c + 1}-${b}`
            getDateNow(new Date(date))
            setDisableNext(false)
        } else {
            let a = new Date(startDate).setDate(new Date(startDate).getDate() + val);
            let b = new Date(a).getDate()
            let c = new Date(a).getMonth()
            let d = new Date(a).getFullYear()
            let date = `${d}-${c + 1}-${b}`
            getDateNow(new Date(date))
            setDisableNext(false)
        }
        setUpdateRange(fixRange)
    }

    const onClose = () => {
        setVisibleDetail(false)
    }

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );
    // console.log(jadwal);
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            {loading ? loadingComponent : null}
            <div style={{ paddingTop: 20, paddingLeft: 0, width: "20%", backgroundColor: 'transparent', marginTop: 10, borderRadius: 10, height: '85vh', overflow: 'auto' }}>
                <Typography style={{ color: '#278863' }}>List Nama Klinik</Typography>
                <hr style={{ marginTop: 0 }} />
                {
                    !visibleSearch ?
                        <img title="cari klinik" onClick={() => setVisibleSearch(true)} src={ic_search} style={{ marginBottom: 10, cursor: 'pointer' }} />
                        :
                        <SearchComponent
                            placeholder={"Input Nama Klinik"}
                            onSearch={(val)=>{
                                doFilter(val)
                                setSearchName(null)
                            }}
                            onDelete={()=>{
                                setSearchName(null)
                                setVisibleSearch(false)
                                doFilter(null)
                            }}
                        />
                }
                {
                    list.map((el, idx) => {
                        return (
                            <div style={{ cursor: "pointer" }} onClick={() => handleClick(el)}>
                                <Typography style={{ fontSize: 14, padding: 3, color: jadwal === el ? '#278863' : '#c8c8c8', borderLeft: jadwal === el ? '3px solid green' : null, borderSpacing: jadwal === el ? "0, 0, 0, 370" : null, }}>{el.name}</Typography>
                            </div>
                        )
                    })
                }
            </div>
            <div style={{ paddingTop: 20, width: "75%", marginTop: -3 }}>
                <div style={{ display: 'flex' }}>
                </div>
                <div>
                    {list && list ?
                        <Paper style={{ width: '100%', borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', scrollBehavior: true, marginTop: 10 }} >
                            <div style={{ display: 'flex', paddingLeft: 25, paddingTop: 30 }}>
                                <img src={back} style={{ cursor: 'pointer', width: 16, height: 16, marginTop: 5, marginRight: 15 }} onClick={() => handleBack(7)} />
                                <img src={next} style={{ cursor: 'pointer', width: 16, height: 16, marginTop: 5, marginRight: 10 }} onClick={() => handleNext(7)} />
                                {startDate ?
                                    <Typography> {displayStartDate} - {displayEndDate}  </Typography>
                                    : null
                                }
                            </div>
                            {value.schedule ?
                                <div>
                                    <div style={{ marginLeft: 23, marginTop: 10 }}>
                                        {create && (
                                            <button
                                                style={{ backgroundColor: 'transparent', border: 'transparent', borderColor: 'transparent', outline: 'none' }}
                                                onClick={() => history.push({
                                                    pathname: '/schedule/tambah-jadwal-poliklinik',
                                                    name: 'Tambah Jadwal Klinik',
                                                    search: '?update=true',  // query string
                                                    state: {  // location state
                                                        idPoli: jadwal.id,
                                                        namaPoli: jadwal.name
                                                    },
                                                })}
                                            >
                                                <div style={{ display: 'flex', height: 30, width: 150, backgroundColor: '#2a9c6c', borderRadius: 70 }}>
                                                    <img style={{ margin: 'auto', width: 25, marginTop: 3, marginRight: 3 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" />
                                                    <Typography style={{ fontSize: 13, margin: 'auto', marginRight: 10, color: 'white' }}>Tambah Jadwal</Typography>
                                                </div>
                                            </button>
                                        )}
                                    </div>
                                    {read && (
                                        <MuiThemeProvider theme={getMuiTheme()}>
                                            <MUIDataTable
                                                data={value.schedule}
                                                columns={columns}
                                                options={options}
                                            />
                                        </MuiThemeProvider>
                                    )}
                                </div>
                                :
                                <Paper style={{ width: '100%', height: '380px', margin: 'auto', justifyContent: 'center', textAlign: 'center', borderRadius: 20, marginTop: 0, paddingTop: 50 }} >
                                    <h1 style={{ margin: 'auto' }}>Silahkan pilih Klinik</h1>
                                </Paper>
                            }
                        </Paper>
                        : null
                    }
                </div>
                {visibleEdit ?
                    <EditJadwalPoli
                        onClose={() => setVisibleEdit(false)}
                        detail={selectedSchedule}
                        refresh={() => getJadwalFilter(startDate, endDate)}
                        messageAlert={(message) => setMessageAlert(message)}
                        openAlert={(bool) => setOpenAlert(bool)}
                        statusAlert={(message) => setStatusAlert(message)}
                    />
                    : null
                }
            </div>
        </div>
    )
}